export function getApplicationNode() {
    return document.getElementById('main')!;
}
